var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"outlined":"","color":"error"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v("Löschen")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }